import { baseApiUrl } from '@fund-base/constants/general/general.constants';

export const notificationsBaseApiUrl = `${baseApiUrl}/notifications`;
export const notificationsApiUrl = `${notificationsBaseApiUrl}/get-notifications`;
export const readNotificationsApiUrl = `${notificationsBaseApiUrl}/read`;
